require('isomorphic-fetch')

export * from './standalone'
